import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "w-full mx-auto p-6 bg-white shadow-md" }
const _hoisted_2 = { class: "mb-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", {
  for: "topic",
  class: "block text-gray-600"
}, "Asunto:", -1)
const _hoisted_4 = { class: "mb-4" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", {
  for: "from",
  class: "block text-gray-600"
}, "Email:", -1)
const _hoisted_6 = { class: "mb-4" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", {
  for: "message",
  class: "block text-gray-600"
}, "Mensaje:", -1)
const _hoisted_8 = { class: "text-center" }
const _hoisted_9 = {
  type: "submit",
  class: "px-4 py-2 bg-[#d59b6a] text-white hover:bg-[#8c6648] focus:outline-none focus:ring focus:border-blue-300"
}
const _hoisted_10 = {
  key: 0,
  class: "w-5 h-5 border-t-4 border-black-500 border-solid rounded-full animate-spin"
}
const _hoisted_11 = { key: 1 }

import axios from "axios";
import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ContactForm',
  setup(__props) {

const emailForm = ref(null);
const isLoading = ref();
const formData = { topic: "", from: "", message: "" };
const submitForm = async () => {
  try {
    isLoading.value = true;
    await axios.post(
      " https://5e9a57oic6.execute-api.us-east-2.amazonaws.com/default/sendEmail",
      {
        name: formData.topic,
        message: formData.message,
        email: formData.from,
      },
      { headers: { "Content-Type": "application/json" } }
    );

    setTimeout(() => {
      emailForm.value.reset();
    }, 100);
  } catch (error) {
    console.log(error);
  } finally {
    isLoading.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", {
      onSubmit: _withModifiers(submitForm, ["prevent"]),
      ref_key: "emailForm",
      ref: emailForm
    }, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.topic) = $event)),
          type: "text",
          id: "topic",
          name: "topic",
          class: "w-full px-4 py-2 border focus:outline-none focus:ring focus:border-[#181f35]",
          required: ""
        }, null, 512), [
          [_vModelText, formData.topic]
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.from) = $event)),
          type: "email",
          id: "from",
          name: "from",
          class: "w-full px-4 py-2 border focus:outline-none focus:ring focus:border-[#181f35]",
          required: ""
        }, null, 512), [
          [_vModelText, formData.from]
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _withDirectives(_createElementVNode("textarea", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.message) = $event)),
          id: "message",
          name: "message",
          rows: "4",
          class: "w-full px-4 py-2 border focus:outline-none focus:ring focus:border-[#181f35]",
          required: ""
        }, null, 512), [
          [_vModelText, formData.message]
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("button", _hoisted_9, [
          (isLoading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10))
            : (_openBlock(), _createElementBlock("div", _hoisted_11, "Enviar"))
        ])
      ])
    ], 544)
  ]))
}
}

})